import { render, staticRenderFns } from "./insights.vue?vue&type=template&id=538a7433&scoped=true"
import script from "./insights.vue?vue&type=script&lang=js"
export * from "./insights.vue?vue&type=script&lang=js"
import style0 from "./insights.vue?vue&type=style&index=0&id=538a7433&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538a7433",
  null
  
)

export default component.exports